// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__23n7W","loaderOuter":"PageOverlayLoader_loaderOuter__MRmZh"};